import Icon from '@/asset/Icon'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import type { TextFormatType } from 'lexical'
import { $getSelection, $isRangeSelection, FORMAT_TEXT_COMMAND } from 'lexical'
import { useCallback, useEffect, useState } from 'react'
import Button from 'react-bootstrap/Button'
import ButtonGroup from 'react-bootstrap/ButtonGroup'

type TextFormat = Partial<Record<TextFormatType, boolean>>

export default function TextFormatUIPlugin() {
  const [editor] = useLexicalComposerContext()

  const [textFormat, setTextFormat] = useState<TextFormat>({
    bold: false,
    italic: false,
    underline: false,
    strikethrough: false,
  })

  const updateUI = useCallback(() => {
    const selection = $getSelection()
    if ($isRangeSelection(selection)) {
      setTextFormat({
        bold: selection.hasFormat('bold'),
        italic: selection.hasFormat('italic'),
        underline: selection.hasFormat('underline'),
        strikethrough: selection.hasFormat('strikethrough'),
      })
    }
  }, [])

  useEffect(() => {
    return editor.registerUpdateListener(({ editorState }) => {
      editorState.read(() => {
        updateUI()
      })
    })
  }, [editor, updateUI])

  return (
    <ButtonGroup className="me-2" aria-label="format group">
      {(Object.entries(textFormat) as [TextFormatType, boolean][]).map(([fmt, active]) => (
        <Button
          key={fmt}
          active={active}
          onClick={() => editor.dispatchCommand(FORMAT_TEXT_COMMAND, fmt)}
          variant="outline-secondary"
        >
          <Icon type={fmt} />
        </Button>
      ))}
    </ButtonGroup>
  )
}
